<template>
  <div class="ChangePersonDialog">
    <el-dialog
      title="更换负责人"
      :visible.sync="open"
      :close-on-click-modal="true"
      :before-close="handleClose"
      width="550px"
    >
      <div class="ChangePersonDialog-box">
        <el-form :inline="true" ref="formRef" :model="form" :rules="rules">
          <div class="form-box">
            <el-form-item label="选择负责人" prop="newDocId">
              <el-select style="width: 280px;" v-model="form.newDocId" clearable placeholder="请选择负责人">
                <el-option v-for="item in leaderList"
                           :key="item.docId"
                           :label="item.docName"
                           :value="item.docId" />
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <div class="prompt">温馨提示：需要交接的负责人请加入当前分组</div>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="btn-box">
        <el-button @click="handover" class="btn" type="primary"
          >交 接</el-button
        >
        <el-button @click="handleClose(Cancel)" class="btn">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "ChangePersonDialog",
  props: {
    value: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    doctorID: {
      type: String,
      default: () => {
        return "";
      },
    },
    groupId: {
      type: String,
      default: () => {
        return "";
      },
    },
    leaderList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      form: {
        newDocId: "",
      },
      rules: {
        newDocId: [{ required: true, message: "请选择负责人", trigger: "blur" }],
      },
    };
  },
  computed: {
    open: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },
  methods: {
    handover() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.confirmApi()
        }
      });
    },
    async confirmApi() {
      try{
        const res = await this.$post("group/exitGroup",{
          ...this.form,
          docId: this.doctorID,
          groupId: this.groupId,
          type: 1.
        })
        if (!res) return false;
        // eslint-disable-next-line no-unused-vars
        const { data } = res;
        this.open = false;
        this.$emit("confirm");
      }catch (e) {
        console.error(e);
      }
    },
    handleClose(done) {
      this.$refs.formRef.resetFields();
      done();
    },
    Cancel() {
      this.open = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.ChangePersonDialog-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .form-box {
    display: flex;
    flex-direction: column;
    .prompt {
      color: #b3b3b3;
      font-size: 14px;
      margin-left: 90px;
      margin-top: 10px;
    }
  }
}
.btn-box {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #ebecf0;
  margin-top: 20px;
  padding-top: 20px;
  gap: 20px;
  .btn {
    width: 90px;
    height: 36px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
::v-deep .el-dialog__header {
  background-color: #1a7cf2;
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__headerbtn {
    font-size: 20px;
    .el-dialog__close {
      color: #fff;
    }
  }
}
::v-deep .el-form-item {
  margin-bottom: 0px;
}
</style>
